import { useEffect } from 'react';
import { useRouter } from '../hooks/useRouter';
import { useBrowser } from '../services/BrowserService';

export const ForceFullReload = () => {
  const asPath = useRouter()?.asPath;
  const { window } = useBrowser();

  useEffect(() => {
    if (asPath) window?.location.reload();
  }, [asPath, window?.location]);

  return null;
};
